import {Head} from '@inertiajs/react';
import {PageProps} from '@/types';
import HomePageContent from "@/Pages/Home/Partials/HomePageContent";
import Main from "@/Pages/Home/Partials/Main";
import GuestLayout from "@/Layouts/Guest/GuestLayout";
import useTranslations from "@/hooks/useTranslations";

export default function Home({}: PageProps) {
    const { __ } = useTranslations();

    return (
        <GuestLayout>
            <Head title="Welcome">
                <title>{__('home.meta.title')}</title>
                <meta name="description"
                      content={__('home.meta.description')}/>
            </Head>
            <Main />
            <div className="py-10"></div>
            <HomePageContent/>
        </GuestLayout>
    );
}
